export default __webpack_public_path__ + "static/media/girl2.7f548ad4.png";